import styled from 'styled-components';

const StyledDiv = styled.div`
	font-family: GT Walsheim Pro;
	font-size: 14px;
	color: #ffffff;
`;

export { StyledDiv as ContentRowText };
